import { createReducer, on } from "@ngrx/store";
import { initialState } from "./state";
import * as AppActions from "./actions";

export const appReducer = createReducer(
  initialState,

  on(AppActions.changeLanguage, (state, { language }) => ({ ...state, language })),
);
